import axios from "axios";

export const BASE_URL = "https://testbcashflow.taysirsolutions.net/";
// process.env.REACT_APP_HOST_API;
export const BASE_URL_ERP = "https://kounouz-crm.wind-erp.com/";
// process.env.REACT_APP_API_ERP;


export const AXIOS = axios.create({ baseURL: BASE_URL + "api/" });

export const AXIOS_ERP = axios.create({
  baseURL: BASE_URL_ERP + "api/",
});
